<template>
  <div class="text-center">
    <v-dialog
      v-if="!loading"
      v-model="dialog"
      width="500"
      style="z-index: 9998"
      :persistent="true"
    >
      <v-card>
        <v-card-title class="text-h5 lighten-2 d-flex justify-center">
          LOGIN
        </v-card-title>
        <v-card-actions>
          <v-container>
            <v-row no-gutters>
              <v-col cols="12">
                <v-text-field
                  v-model="email"
                  outlined
                  type="email"
                  label="Email"
                  :error-messages="emailErrors"
                  required
                  @input="$v.email.$touch()"
                  @blur="$v.email.$touch()"
                  dense
                ></v-text-field>
                <v-text-field
                  class="mt-6"
                  v-model="password"
                  outlined
                  type="password"
                  label="Password"
                  :error-messages="passwordErrors"
                  required
                  @input="$v.password.$touch()"
                  @blur="$v.password.$touch()"
                  dense
                ></v-text-field>
              </v-col>

              <v-col cols="12" class="d-flex justify-center">
                <v-btn
                  @click="authUser"
                  class="dv-button mt-2"
                  :disabled="passwordErrors.length != 0 || emailErrors.length != 0 "
                  outlined
                  large
                >
                  Enter
                </v-btn>
              </v-col>
            </v-row>
            <hr class="mt-4 info">
            <v-row no-gutters class="mt-2">
              <v-col cols="12" class="d-flex justify-center">
                <a class="mb-1 mt-1 color-white" @click="$router.push({ name: 'RegisterAccount' }).catch(() => {})">Registration & object creation</a>
              </v-col>
            </v-row>
          </v-container>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>
<script>
import storageService from '../services/storageService'
import md5 from 'md5'
import {mapGetters, mapActions, mapMutations} from 'vuex'
import { validationMixin } from 'vuelidate'
import { required, minLength, email } from 'vuelidate/lib/validators'
import validationService from '@/services/validationService'

export default {
  mixins: [validationMixin],
  validations: {
    password: { required, minLength: minLength(4) },
    email: { required, email }
  },
  name: 'Login',
  data(){
    return {
      dialog: false,
      email: '',
      password: '',
      loading: true
    }
  },
  computed:{
    passwordErrors () {
      return validationService.passwordErrors(this.$v.password)
    },
    emailErrors () {
      return validationService.emailErrors(this.$v.email)
    },
  },
  methods: {
    ...mapActions(['authLogin']),
    ...mapMutations(['saveAccessToken', 'saveRefreshToken']),
    async authUser(){
      this.$root.$emit('loading', "start")
      await this.authLogin({
        email: this.email,
        password: md5(this.password)
      })
      .then(result => {
        console.log(result)
        this.$router.push('Account').catch(() => {})
        this.$root.$emit('loading', "end")
        this.$root.$emit("reMountApp")
      })
      .catch(e => {
        console.log(e)
        this.$root.$emit('globalError', e.code)
        this.$root.$emit('loading', "end")
      })
    }
  },
  mounted() {
    this.loading = true
    this.$root.$emit('loading', "start")
    setTimeout(() => {
      this.dialog = true
    }, 100)
    this.$nextTick(() => {
      this.dialog = true
    })
    this.token = storageService.getToken()
    this.saveAccessToken(this.token)
    this.saveRefreshToken(storageService.getRefreshToken())
    if(storageService.getSelectedDevice())
    if(this.token != null){
      this.$root.$emit('loading', "end")
      this.$router.push('Account').catch(() => {})
    }
    this.loading = false
    this.$root.$emit('loading', "end")
  },
}
</script>
<style>
.dv-button{
  width: 50%;
}
</style>